import { TweenMax, TimelineMax, Power4 } from 'gsap'
import ScrollMagic from 'scrollmagic'

export default (function() {

  function init(scrollController) {

    // Case study captions
    const casestudyCaptionBlocks = Array.from(document.querySelectorAll('.work-detail .content-block.js-has-overlay-block:not(.center-text)'))
    const casestudyCaptions = casestudyCaptionBlocks.map((captionBlock) => captionBlock.querySelector('.overlay-copy'))

    casestudyCaptions.forEach((caption, i, arr) => {

      if (!caption) {
        return;
      }

      let mark = caption.querySelector('.marker-wrapper')
      let topCaption = caption.className.indexOf('top') !== -1;
      let topMark = mark && mark.className.indexOf('top') !== -1;
      let directionMultiplier = topCaption ? 1 : -1
      let captionDuration, markDuration;
      let offset = 0

      if (!topCaption) {
        offset = 200
      } else {
        offset = -50
      }

      if (!topMark) {
        captionDuration = 1
        markDuration = 1.2
      } else {
        captionDuration = 1.2
        markDuration = 1
      }

      let tween = new TimelineMax()

      let captionTween = TweenMax.fromTo(caption, captionDuration,
        { css: { y: 200 * directionMultiplier, opacity: 0, force3D: true }},
        { css:{ y: 0, opacity: 1, force3D: true } },
        { ease: Power4.easeOut })
      tween.add(captionTween, `captionTimeline${i}`)

      if (mark) {
        let markTween = TweenMax.fromTo(mark.querySelector('svg'), markDuration,
          { css: { y: 75 * directionMultiplier, force3D: true }},
          { css:{ y: 0, force3D: true } },
          { ease: Power4.easeOut })
        tween.add(markTween, `captionTimeline${i}`)
      }

      let scene = new ScrollMagic.Scene({
        triggerElement: casestudyCaptionBlocks[i],
        triggerHook: topCaption ? 'onEnter' : 'onCenter',
        duration: casestudyCaptionBlocks[i].offsetHeight * .6,
        offset: topCaption ? 200 : 10,
      })
      .setTween(tween)
      .addTo(scrollController);
    })
  }

  return {
    init
  }

})();
